module.exports = __webpack_public_path__ + "media/48.c9ab45f5.wav";